import http from './Http';

/**
 * Obtiene sesiones de aprendizaje con filtros dinámicos.
 * Devuelve { total_count, items } según la estructura del backend.
 */
const obtenerSesiones = (filtros = {}) => {
  return http.get('/sesiones/', { params: filtros });
};

const existeEnInstitucionActiva = (tipoSesion) => {
  const params = {};

  if (tipoSesion) {
    params.tipo_sesion = tipoSesion;
  }

  return http.get('/sesiones/validaciones/existe-en-institucion-activa', { params });
};

const eliminarSesion = (sesionId) => {
  return http.delete(`/sesiones/${sesionId}`);
};

// Exportación unificada
const SesionsService = {
  obtenerSesiones,
  existeEnInstitucionActiva,
  eliminarSesion,
};

export default SesionsService;
